// extracted by mini-css-extract-plugin
export default {"root":"Configuration_root__6naeC","sidebar":"Configuration_sidebar__eYlTZ","content":"Configuration_content__cf9Gj"};